import { render, staticRenderFns } from "./AccountLogo.vue?vue&type=template&id=ed8546d8&scoped=true&"
import script from "./AccountLogo.vue?vue&type=script&lang=ts&"
export * from "./AccountLogo.vue?vue&type=script&lang=ts&"
import style0 from "./AccountLogo.vue?vue&type=style&index=0&id=ed8546d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8546d8",
  null
  
)

export default component.exports